<template>
    <report-list-view class="report-frame-list-view" :downloadable="downloadable" :filterable="filterable">
        <template slot="tableColumns">
            <veui-table-column field="id"
                :title="`${store.pageType}名称/ID`">
                <template slot-scope="props">
                    <veui-span>
                        {{props.item.name}}
                        <br>
                        {{props.item.id}}
                    </veui-span>
                </template>
            </veui-table-column>
            <veui-table-column field="previewUrl"
                :title="`${store.pageType}缩略图`"
                width="150">
                <template slot-scope="props">
                    <div class="img-container" :style="{backgroundImage: `url(${https(props.item.previewUrl)})`}"/>
                </template>
            </veui-table-column>
            <veui-table-column field="aderName"
                title="广告主">
                <template slot-scope="props">
                    <div class="pre-wrap">{{props.item.aderName}}</div>
                </template>
            </veui-table-column>
            <veui-table-column field="statusLabel"
                title="状态"
                width="90">
                <template slot-scope="props">
                    <veui-span :class="props.item.statusColor">
                        {{props.item.statusLabel}}
                    </veui-span>
                </template>
            </veui-table-column>

            <veui-table-column field="pv" title="展现" width="90"/>
            <veui-table-column field="click" title="点击" width="90"/>
            <veui-table-column field="clickRatioPercent" title="点击率" width="90"/>
            <veui-table-column field="operation" title="其他" width="120">
                <template slot-scope="props">
                    <template v-if="isBaseReport">
                        <veui-button ui="link primary" @click="$emit('detail', props.item.id)">详细数据</veui-button>
                    </template>
                    <template v-else>
                        <veui-button ui="link primary" @click="$emit('report', props.item.id, 'component')">组件数据</veui-button>
                        <veui-button ui="link primary" @click="$emit('report', props.item.id, 'link')">子链点击率</veui-button>
                    </template>
                    <veui-button ui="link" @click="showTrend(props.item.id, `${props.item.name}—趋势曲线`)">
                        趋势曲线 <veui-icon name="eye"/>
                    </veui-button>
                </template>
            </veui-table-column>
        </template>

        <template slot="after">
            <report-chart-dialog :open.sync="chartDialogVisible"
                :title="chartName"
                :chart-data="this.store.trendData"
                report-type="base"/>
        </template>
    </report-list-view>
</template>

<script>
import 'veui-theme-one-icons/eye';
import Model from './FrameListModel';
import ListView from './ReportListView';
import {httpsTransform} from '@/common/utils';
import {Column, Button, Span, Icon} from 'veui';
import ReportChartDialog from './ReportChartDialog';
import createView from '@baidu/ve-ria/views/createView';

export default createView(ListView, Model, {
    name: 'frame-list-view',
    components: {
        ReportChartDialog,
        'veui-table-column': Column,
        'veui-button': Button,
        'veui-span': Span,
        'veui-icon': Icon
    },
    props: {
        filterable: Boolean,
        isBaseReport: Boolean,
        downloadable: Boolean
    },
    data() {
        return {
            chartDialogVisible: false,
            chartName: ''
        };
    },
    methods: {
        async showTrend(id, name) {
            await this.store.requestTrendData({id});
            this.chartDialogVisible = true;
            this.chartName = name;
        },
        https(value) {
            return httpsTransform(value);
        }
    }
});
</script>
